import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const token = localStorage.getItem('token');
      if(token) {
      window.location = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;